import WorkTimeWeekly from './WorkTimeWeekly';

export default WorkTimeWeekly;
